/**
 * Класс AbstractExporter
 */
class AbstractExporter {
    constructor(params) {
        this.params = params;
    }

    serialize(features) {
        return JSON.stringify(features);
    }

    write(features) {
        return JSON.stringify(features);
    }

    saveAs(params) {
    }
}

module.exports = AbstractExporter;